import React, { Component } from 'react';

import { InputText } from 'primereact/inputtext';
import "./style.scss"

/* 
	--- Argumentos soportados --- 
		codeSec1:  string 
		codeSec2:  string 
		codeSec3:  string 
		codeSec4:  string 
		codeSec5:  string 
		codeSec6:  string 
*/

class SecureCode extends Component{

	constructor( props ){
		super( props );

		this.state = {
			secureCode:{
				codeSec1: this.props.secureCode.codeSec1,
				codeSec2: this.props.secureCode.codeSec2,
				codeSec3: this.props.secureCode.codeSec3,
				codeSec4: this.props.secureCode.codeSec4,
				codeSec5: this.props.secureCode.codeSec5,
				codeSec6: this.props.secureCode.codeSec6
			}
		}
	}



	changeCode1 = ( codeSec1 ) => {
		this.setState( ( prevState ) => ( 
			{  secureCode: { ...prevState.secureCode, codeSec1}  }
		), () => {this.props.getSecureCode(this.state.secureCode)} )
		//this.state.secureCode.codeSec1 = codeSec1;
	}

	changeCode2 = ( codeSec2 ) => {
		this.setState( ( prevState ) => (
			{  secureCode: { ...prevState.secureCode, codeSec2}  }
		), () => {this.props.getSecureCode(this.state.secureCode)} )
		//this.state.secureCode.codeSec2 = codeSec2;
		
	}

	changeCode3 = ( codeSec3 ) => {
		this.setState( ( prevState ) => (
			{  secureCode: { ...prevState.secureCode, codeSec3}  }
		), () => {this.props.getSecureCode(this.state.secureCode)} )
		//this.state.secureCode.codeSec3 = codeSec3;
		
	}

	changeCode4 = ( codeSec4 ) => {
		this.setState( ( prevState ) => (
			{  secureCode: { ...prevState.secureCode, codeSec4}  }
		), () => {this.props.getSecureCode(this.state.secureCode)} )
		//this.state.secureCode.codeSec4 = codeSec4;
		
	}

	changeCode5 = ( codeSec5 ) => {
		this.setState( ( prevState ) => (
			{  secureCode: { ...prevState.secureCode, codeSec5}  }
		), () => {this.props.getSecureCode(this.state.secureCode)} )
		//this.state.secureCode.codeSec5 = codeSec5;
	}

	changeCode6 = ( codeSec6 ) => {
		this.setState( ( prevState ) => (
			{  secureCode: { ...prevState.secureCode, codeSec6}  }
		), () => {this.props.getSecureCode(this.state.secureCode)} )
		//this.state.secureCode.codeSec6 = codeSec6;
	}

	render(){
		const {
			secureCode
		} = this.props;

		return(
			<Page 
				secureCode = { this.state.secureCode }
				changeCode1 = { this.changeCode1 }
				changeCode2 = { this.changeCode2 }
				changeCode3 = { this.changeCode3 }
				changeCode4 = { this.changeCode4 }
				changeCode5 = { this.changeCode5 }
				changeCode6 = { this.changeCode6 }
			/>
		);
	}
}

export default SecureCode;


const Page = props => {

	const nameInput1 = React.createRef();
	const nameInput2 = React.createRef();
	const nameInput3 = React.createRef();
	const nameInput4 = React.createRef();
	const nameInput5 = React.createRef();
	const nameInput6 = React.createRef();
	const {
		secureCode,
		changeCode1,
		changeCode2,
		changeCode3,
		changeCode4,
		changeCode5,
		changeCode6
	} = props;


	return(
		
		<div className="codigoInputs">
			<input
				type="text"
				keyfilter="int"
				maxLength="1"
				max="9"
				min="0"
				autoComplete="off" 
				name="sc1"
        ref={nameInput1}
				value={ secureCode.codeSec1 }
				aria-label="Token Numérico" onChange={ 
					(event) => {
						const newCode1 = event.target.value
						if(newCode1 === ''){ changeCode1(newCode1); }
						if (/\d/g.test(newCode1) ){ changeCode1(newCode1);
							if(newCode1.length === 1){ nameInput2.current.focus(); nameInput2.current.select(); }
						 }
					} }  />
			<input
				type="text"
				maxLength="1"
				keyfilter="int"
				max="9"
				min="0"
				autoComplete="off" 
				name="sc2"
				value={ secureCode.codeSec2 }
				ref={nameInput2}
				aria-label="Token Numérico" onChange={ 
					(event) => {
						const newCode2 = event.target.value
						if(newCode2 === ''){ changeCode2(newCode2); nameInput1.current.focus()}
						if (/([0-9]+)/g.test(event.target.value) ){ changeCode2(newCode2); 
							if(newCode2.length === 1){ nameInput3.current.focus(); nameInput3.current.select(); }
						}
					} }  />
			<input
				type="text"
				maxLength="1"
				keyfilter="int"
				max="9"
				min="0"
				autoComplete="off" 
				name="sc3"
				value={ secureCode.codeSec3 }
				ref={nameInput3} 
				aria-label="Token Numérico" onChange={ 
					(event) => {
						const newCode3 = event.target.value
						if(newCode3 === ''){ changeCode3(newCode3); nameInput2.current.focus() }
						if (/([0-9]+)/g.test(event.target.value) ){ changeCode3(newCode3); 
							if(newCode3.length === 1){ nameInput4.current.focus(); nameInput4.current.select(); }
						}
					} }  />
			{/* <span>-</span> */}
			<input
				type="text"
				maxLength="1"
				keyfilter="int"
				max="9"
				min="0"
				autoComplete="off" 
				name="sc4"
				value={ secureCode.codeSec4 }
				ref={nameInput4} 
				aria-label="Token Numérico" onChange={ 
					(event) => {
						const newCode4 = event.target.value
						if(newCode4 === ''){ changeCode4(newCode4); nameInput3.current.focus()}
						if (/([0-9]+)/g.test(event.target.value) ){
							changeCode4(newCode4); 
							if(newCode4.length === 1){ nameInput5.current.focus(); nameInput5.current.select(); }
						}
					} }  />
			<input
				type="text"
				maxLength="1"
				keyfilter="int"
				max="9"
				min="0"
				autoComplete="off" 
				name="sc5"
				value={ secureCode.codeSec5 }
				ref={nameInput5} 
				aria-label="Token Numérico" onChange={ 
					(event) => {
						const newCode5 = event.target.value
						if(newCode5 === ''){ changeCode5(newCode5); nameInput4.current.focus()}
						if (/([0-9]+)/g.test(event.target.value) ){ changeCode5(newCode5); 
							if(newCode5.length === 1){ nameInput6.current.focus(); nameInput6.current.select(); }
						}
					} }  />
			<input
				type="text"
				maxLength="1"
				keyfilter="int"
				max="9"
				min="0"
				autoComplete="off" 
				name="sc6"
				value={ secureCode.codeSec6 }
				ref={nameInput6} 
				aria-label="Token Numérico"  onChange={ 
					(event) => {
						const newCode6 = event.target.value
						if(newCode6 === ''){ changeCode6(newCode6); nameInput5.current.focus()}
						if (/([0-9]+)/g.test(event.target.value) ){ changeCode6(newCode6); }
					} } />
		</div>

	)

}
